import { render } from "./ConversationVariables.vue?vue&type=template&id=900f7e5a&scoped=true"
import script from "./ConversationVariables.vue?vue&type=script&lang=js"
export * from "./ConversationVariables.vue?vue&type=script&lang=js"

import "./ConversationVariables.vue?vue&type=style&index=0&id=900f7e5a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-900f7e5a"]])

export default __exports__